import { AddressWithUnom } from './address';

export enum STATS_EVENTS {
  VIEW = 'VIEW',
  FOCUS = 'FOCUS',
  ADDRESS_SELECT = 'ADDRESS_SELECT',
  CALENDAR = 'CALENDAR',
  HAS_HOT_WATER = 'HAS_HOT_WATER',
  OUTAGE_PASSED = 'OUTAGE_PASSED',
  EMPTY_OUTAGE_INFO = 'EMPTY_OUTAGE_INFO',
  LINK_CLICK = 'LINK_CLICK',
  ERROR_MODAL = 'ERROR_MODAL',
  GET_ADDRESS_REQUEST_TIME = 'GET_ADDRESS_REQUEST_TIME',
  ADDRESS = 'ADDRESS',
}

export type STATS_EVENTS_PARAMS = {
  [STATS_EVENTS.VIEW]: [];
  [STATS_EVENTS.FOCUS]: [];
  [STATS_EVENTS.ADDRESS_SELECT]: [AddressWithUnom];
  [STATS_EVENTS.CALENDAR]: [];
  [STATS_EVENTS.HAS_HOT_WATER]: [];
  [STATS_EVENTS.OUTAGE_PASSED]: [];
  [STATS_EVENTS.EMPTY_OUTAGE_INFO]: [];
  [STATS_EVENTS.LINK_CLICK]: [string];
  [STATS_EVENTS.ERROR_MODAL]: [string];
  [STATS_EVENTS.GET_ADDRESS_REQUEST_TIME]: [number];
  [STATS_EVENTS.ADDRESS]: [string];
};
